{
    "bannerImgs": ["tim.png"]
}
